import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import OnboardingSeedlangRegistration from './onboarding_seedlang_registration';
import OnboardingMemrevRegistration from './onboarding_memrev_registration';
import withRouteParams from 'utils/with_route_params';

@observer
class OnboardingRegistration extends React.Component {
  render() {
    return (
      AppUI.siteIsSeedlang ? (
        <OnboardingSeedlangRegistration key={this.props.location.pathname} {...this.props} />
      ) : (
        <OnboardingMemrevRegistration {...this.props} />
      )
    );
  }
}

export default withRouteParams(OnboardingRegistration);
